module.exports = __webpack_public_path__ + "assets/elections_black.065eb67c.svg";